import { render, staticRenderFns } from "./datatableListaAppuntamenti.vue?vue&type=template&id=6df216dc"
import script from "./datatableListaAppuntamenti.vue?vue&type=script&lang=js"
export * from "./datatableListaAppuntamenti.vue?vue&type=script&lang=js"
import style0 from "./datatableListaAppuntamenti.vue?vue&type=style&index=0&id=6df216dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports